import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {PermissionAssigneeTargetLinkContainerModel} from '../../../../../models/aggregates/permissions';
import {Core2Config} from '../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class PermissionAssigneeTargetService extends BaseApiTemplateService<PermissionAssigneeTargetLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'permission-assignee-target';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_MICRO_SERVICES_URL_PREFIX + Core2Config.DOMAIN_PREFIX +'permission-assignee-target';
    this.endpoint_path = Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'permission-assignee-target';
    this.httpClient = http;
  }
}


